// Port of reachchms-backend _shared/announcements.ts smsSegments() — keep the
// two implementations in sync. GSM-7 detection controls the 160/70-char limit
// and the 153/67-char multi-segment boundary. Any non-GSM char (emoji, some
// punctuation) forces UCS-2 encoding for the whole message.
const GSM_BASIC = new Set('@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΘΞ\u001bÆæßÉ !"#¤%&\'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà')
const GSM_EXTENDED = new Set('\f^{}\\[~]|€')

export const smsSegments = (text) => {
    const gsm = [...text].every(char => GSM_BASIC.has(char) || GSM_EXTENDED.has(char))
    const units = gsm ? [...text].reduce((count, char) => count + (GSM_EXTENDED.has(char) ? 2 : 1), 0) : text.length
    const single = gsm ? 160 : 70
    return { encoding: gsm ? 'GSM-7' : 'Unicode', units, segments: Math.max(1, units <= single ? 1 : Math.ceil(units / (gsm ? 153 : 67))) }
}
